import Typography from '@material-ui/core/Typography'

import { AnswerContentProps } from './interface'
import { renderAnswer } from './renderAnswer'

export function AnswerContent({ className, contents, skillApi, cardId }: AnswerContentProps) {
  return (
    <div className="faq-answer-content__answer-wrapper">
      {contents.map((content, i) => {
        if (!content) {
          return null
        }
        return (
          <Typography key={`${i}--${content.text}`} paragraph component="div" className={className}>
            {renderAnswer(content, skillApi, cardId)}
          </Typography>
        )
      })}
    </div>
  )
}
